// extracted by mini-css-extract-plugin
module.exports = {"popup":"styles_popup__38N99","inputField":"styles_inputField__OiP8H","emojiButton":"styles_emojiButton__16yVU"};